import React from "react";
import "./home.css";
import heroImg from "../../components/images/homeImage.png";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Price from "../../components/price/Price";
import WorkoutGallery from "../../components/workout-gallery/workout-gallery";
import Testimonial from "../../components/testimonial/testimonial";
import WhyUs from "../../components/why-us/WhyUs";
import CtaSection from "../../components/cta-section/CtaSection";

function Home() {
  return (
    <>
      <section className="hero-section">
        <div className="hero">
          <div className="hero-left">
            <div className="hero-kicker">
              <span className="hero-badge-dot" />
              Personalni fitness trener · Beograd
            </div>

            <div className="hero-copy">
              <h1 className="hero-title">
                Vaš put ka zdravijem životu
              </h1>

              <p className="hero-sub">
                Personalizovani treninzi, prilagođena ishrana i stalna podrška
                za rezultate koji se vide i osećaju.
              </p>
            </div>

            <div className="hero-actions">
              <a href="/kontakt/" className="hero-btn-primary">Zakaži trening</a>
              <a href="/biografija/" className="hero-btn-secondary">Upoznaj me</a>
            </div>

            <div className="hero-stats">
              <div className="hero-stat">
                <strong>200+</strong>
                <span>Klijenata</span>
              </div>
              <div className="hero-stat">
                <strong>5+</strong>
                <span>Godina iskustva</span>
              </div>
              <div className="hero-stat">
                <strong>4.9</strong>
                <span>Ocena</span>
              </div>
            </div>
          </div>

          <div className="hero-right">
            <img src={heroImg} alt="Mihailo Živanović" />
          </div>
        </div>
      </section>

      <Price />
      <WhyUs />
      <CtaSection />
      <Testimonial />
      <WorkoutGallery />
    </>
  );
}

export default Home;
